"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unauthorizedResponseInterceptor = exports.authRequestInterceptor = void 0;
const getToken_1 = require("./getToken");
function authRequestInterceptor(cfg) {
    const token = getToken_1.getToken();
    if (token) {
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
}
exports.authRequestInterceptor = authRequestInterceptor;
function unauthorizedResponseInterceptor(response) {
    const unauthorizedStatuses = [401, 403];
    if (unauthorizedStatuses.includes(response.status)) {
        window.location.href = '/';
        return;
    }
    return response.data;
}
exports.unauthorizedResponseInterceptor = unauthorizedResponseInterceptor;
